import NavBar from '../components/navbar';
import Footer from '../components/footer';

function Performances() {
    return (
        <>
            <title>Performances</title>
            {/* Navigation Bar w/NavBurger BEGIN */}
            <NavBar />
            {/* Navigation Bar w/NavBurger End */}



            {/* Footer */}
            <Footer />
            {/* Footer END */}
        </>
    );
}

export default Performances;